/**
 * SEARCH
 * Category id for the search results when they render, used to hide the other categories
 */
export const SEARCH_RESULTS_ID = 'search-results';

/**
 * Returns the native emoji string, returned to the consumer on selection of emoji
 * @param unified the unified unicode string from the generated dataset
 */
export const getNativeStringFromUnified = (unified?: string | null): string => {
  if (!unified) return '';

  const codePoints = unified.split('-').map((each: any) => {
    return Number(`0x${each}`);
  });

  return String.fromCodePoint.apply(null, codePoints);
};
